// Modal.js

import React, { useContext, useEffect, useRef, useState } from "react";
import DynamicTextArea from "../DynamicTextArea";
import { useTranslation } from "react-i18next";
import { Spell } from "../../Types/TableTypes";
import { SpellDto } from "../../Types/ApiTypes";
import { convertSpell, getTranslation } from "../../Utils/Converters";
import { AllSpellsContext } from "../../Context/AllSpellsContext";

interface SpellModalEditProps{
    spell: Spell,
    updateSpell: (spell: Spell)=> void,
    deleteSpell: ()=> void,
    closeModal: ()=> void
}

const SpellModalEdit = (props: SpellModalEditProps) => {
    const [spell, setSpell] = useState(props.spell);
    const backgroundaRef = useRef<HTMLDivElement>(null);
    const [foundSpells, setFoundSpells] = useState([] as SpellDto[]);
    const { t } = useTranslation();
    const allSpells = useContext(AllSpellsContext) as SpellDto[];
    const [searchValue, setSearchValue] = useState("");

    useEffect(()=>{
        setSearchValue("");
    },[]);

    return (
        <>{<div className="modal" tabIndex={-1} style={{display: "block"}}>
            <div 
                ref={backgroundaRef}
                className="modal-background" 
                tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" 
                onClick={e=>{
                    if(e.target === backgroundaRef.current)
                    {
                        props.closeModal(); 
                        setFoundSpells([...[] as SpellDto[]]);
                        setSpell(props.spell)
                    }
                }}>
                <div className="modal-dialog" style={{maxWidth: "75%"}}>
                    <form className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                <input 
                                    value={spell.name}
                                    type="text"
                                    placeholder='name'
                                    className="form-control"
                                    name="name"
                                    onChange={handleChange}
                                ></input>
                            </h4>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={t("spell-search")+"..."}
                                    value={searchValue}
                                    onChange={(e) => {
                                        let input = e.target.value;
                                        setSearchValue(input);
                                        let spells = [] as SpellDto[];
                                        if (input.length > 0){
                                                spells = allSpells.filter((spell: SpellDto) => getTranslation(spell.name).toLowerCase().includes(input.toLowerCase()));
                                        }
                                        setFoundSpells([...spells]);
                                    }}
                                ></input>

                                <div className="suggestions">
                                    {foundSpells.length >0  && foundSpells.map((apiSpell :SpellDto, index) => (
                                        <div className="suggestion-item" key={index}
                                            onClick={e=>{
                                                saveSpell(apiSpell);
                                                setFoundSpells([...[] as SpellDto[]]);
                                                setSearchValue("");
                                                // props.closeModal();
                                            }}
                                        >
                                            {getTranslation(apiSpell.name)}
                                        </div>
                                    ))}
                                </div>
                            </div>




                            <button type="button" className="btn-close" onClick={e=>{props.closeModal(); setSpell(props.spell); setFoundSpells([...[] as SpellDto[]]);}} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-wrap text-center">
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-level")}</b></span>
                                    <span className="col-3"><input 
                                        value={spell.level}
                                        type="number"
                                        className="form-control text-center"
                                        name="level"
                                        onChange={handleChange}
                                    ></input></span>
                                    <span className="col-4">{t("spellmodal-concentration")}</span>
                                    <span className="col-2 form-check" style={{margin: "auto"}}>
                                        <input 
                                            checked={spell.concentration}
                                            type="checkbox"
                                            className="text-center form-check-input"
                                            name="level"
                                            onChange={e => {
                                                setSpell({...spell,"concentration": e.target.checked});
                                            }}
                                        ></input>
                                    </span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-castingtime")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.castingTime}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="castingTime"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-range")}</b></span>
                                    <span className="input-group">
                                        <input 
                                            value={spell.range? spell.range.mt : 0}
                                            type="number"
                                            className="form-control text-center"
                                            name="rangeAreaM"
                                            onChange={e => {
                                                let value = parseFloat(e.target.value);
                                                setSpell({...spell,"range": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                                setSpell({...spell,"otherRange": ""});
                                            }}
                                        ></input>
                                        <span className="input-group-text">m</span>
                                        <input 
                                            value={spell.range? spell.range.ft : 0}
                                            name="rangeAreaFt"
                                            type="number"
                                            className="form-control text-center"
                                            onChange={e => {
                                                let value = parseFloat(e.target.value);
                                                setSpell({...spell,"range": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                                setSpell({...spell,"otherRange": ""});
                                            }}
                                        ></input>
                                        <span className="input-group-text">ft</span>
                                        <input 
                                            value={spell.range? spell.range.sq : 0}
                                            name="rangeAreaSq"
                                            type="number"
                                            className="form-control text-center"
                                            onChange={e => {
                                                let value = parseFloat(e.target.value);
                                                setSpell({...spell,"range": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                                setSpell({...spell,"otherRange": ""});
                                            }}
                                        ></input>
                                        <span className="input-group-text">{t("sq")}</span>
                                        <input 
                                            value={spell.otherRange? spell.otherRange : ""}
                                            type="text"
                                            className="form-control text-center"
                                            name="rangeother"
                                            placeholder="other"
                                            onChange={e => {
                                                setSpell({...spell,"range": {"mt": spell.range.mt,"ft":spell.range.ft,"sq": spell.range.sq}});
                                                setSpell({...spell,"otherRange": ""});
                                            }}
                                    ></input>
                                    </span>
                                </div>

                                
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-components")}</b></span>
                                    <span className="input-group">
                                        <span className="input-group-text">V&nbsp;&nbsp;
                                            <input 
                                                type="checkbox"
                                                checked={spell.components.v}
                                                name="v"
                                                onChange={e => {
                                                    setSpell({...spell,"components": {"v": e.target.checked,"s":spell.components.s,"m":spell.components.m}});
                                                }}
                                            ></input>
                                        </span>
                                        <span className="input-group-text">S&nbsp;&nbsp;
                                            <input 
                                                checked={spell.components.s}
                                                name="s"
                                                type="checkbox"
                                                onChange={e => {
                                                    setSpell({...spell,"components": {"v": spell.components.v,"s":e.target.checked,"m":spell.components.m}});
                                                }}
                                            ></input>
                                        </span>
                                        <span className="input-group-text">M&nbsp;&nbsp;
                                            <input 
                                                checked={spell.components.m}
                                                name="m"
                                                type="checkbox"
                                                onChange={e => {
                                                    setSpell({...spell,"components": {"v": spell.components.v,"s":spell.components.s,"m":e.target.checked}});
                                                }}
                                            ></input>
                                        </span>
                                        <input 
                                            value={spell.materials}
                                            type="text"
                                            className="form-control"
                                            name="materials"
                                            placeholder="materials"
                                            onChange={e => {
                                                setSpell({...spell,"materials": e.target.value});
                                            }}
                                    ></input>
                                    </span>
                                </div>
                                    {/* <span className="col-9"><input 
                                        value={spell.components}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="components"
                                        onChange={handleChange}
                                    ></input></span> */}
                                {/* </div> */}
                                {/* <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-material")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.material}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="material"
                                        onChange={handleChange}
                                    ></input></span>
                                </div> */}
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-duration")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.duration}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="duration"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>School</b></span>
                                    <span className="col-9"><input 
                                        value={spell.school}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="school"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-attacktype")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.attackType}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="attackType"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-damagetype")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.damage? spell.damage.type : ""}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="damageType"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-dc")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.dc ? spell.dc.type+spell.dc.success?"("+spell.dc.success+")" : "" : ""}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="dc"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-areaofeffect")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.areaOfEffectType?? ""}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="damageType"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-classes")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.classes}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="classes"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                                <div className="d-flex col-6 p-2">
                                    <span className="col-3"><b>{t("spellmodal-subclasses")}</b></span>
                                    <span className="col-9"><input 
                                        value={spell.subclasses}
                                        type="text"
                                        className="col-12 form-control text-center"
                                        name="subclasses"
                                        onChange={handleChange}
                                    ></input></span>
                                </div>
                            </div>
                            <div className="p-4">
                                <DynamicTextArea
                                    updateText={(text: string)=>{
                                        setSpell({...spell, "description":text});
                                    }}      
                                    placeholder={t("placeholder-spelldescription")}
                                    areaText={spell.description ?? ""}/>
                                <DynamicTextArea
                                    updateText={(text: string)=>{
                                        setSpell({...spell, "higherLevel":text});
                                    }}      
                                    placeholder={t("placeholder-spellhigherlevel")}
                                    areaText={spell.higherLevel ?? ""}/>
                            </div>
                    
                        </div>
                        <div className="modal-footer justify-content-between">
                            <span><button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={e=>{props.deleteSpell(); props.closeModal()}}>{t("modal-delete")}</button></span>
                            <span>
                                <button type="button" className="btn btn-secondary m-1" data-bs-dismiss="modal" onClick={e=>{setSpell(props.spell); props.closeModal(); setFoundSpells([...[] as SpellDto[]]);}}>{t("modal-close")}</button>
                                <button type="button" className="btn btn-primary m-1" onClick={e=>{props.updateSpell(spell); props.closeModal(); setFoundSpells([...[] as SpellDto[]]);}}>{t("modal-save")}</button>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>}</>
    )

    function handleChange(evt: { target: { value: any; name: any; }; }) {
        const value = evt.target.value;
        setSpell({
          ...spell,
          [evt.target.name]: value
        });
      }

    function saveSpell(spell: SpellDto){

        let newSpell = convertSpell(spell);
        setSpell(newSpell);
    }  
}
export default SpellModalEdit;